export const ONBOARD_PLAN_REQUEST = 'ONBOARD_PLAN_REQUEST';
export const ONBOARD_PLAN_ERROR = '  ONBOARD_PLAN_ERROR';
export const ONBOARD_PLAN_SUCCESS = 'ONBOARD_PLAN_SUCCESS';

export const CURRENT_PLAN_REQUEST = 'CURRENT_PLAN_REQUEST';
export const CURRENT_PLAN_ERROR = '  CURRENT_PLAN_ERROR';
export const CURRENT_PLAN_SUCCESS = 'CURRENT_PLAN_SUCCESS';
